import moment from 'moment';
import demoParams from '../../__test__/demoParams';
const { demoMode, demoShortPostedId, demoLongPostedId } = demoParams;

/**
 * Returns an array of Posted Schedules.
 * @param {*} listPostedSchedules
 */
const generateQuickScheduleView = async (listPostedSchedules) => {
  let thisYear = moment().format('YYYY');
  return [
    { name: 'postedDayOneId', id: demoMode ? demoShortPostedId : listPostedSchedules.postedDayOneId, startDate: moment().format('L'), scheduleFormat: 1 },
    { name: 'postedDayTwoId', id: listPostedSchedules.postedDayTwoId, startDate: moment().set('year', thisYear).add(1, 'day').format('L'), scheduleFormat: 1 },
    { name: 'postedDayThreeId', id: listPostedSchedules.postedDayThreeId, startDate: moment().set('year', thisYear).add(2, 'day').format('L'), scheduleFormat: 1 },
    { name: 'postedDayFourId', id: listPostedSchedules.postedDayFourId, startDate: moment().set('year', thisYear).add(3, 'day').format('L'), scheduleFormat: 1 },
    { name: 'postedDayFiveId', id: listPostedSchedules.postedDayFiveId, startDate: moment().set('year', thisYear).add(4, 'day').format('L'), scheduleFormat: 1 },
    { name: 'postedDaySixId', id: listPostedSchedules.postedDaySixId, startDate: moment().set('year', thisYear).add(5, 'day').format('L'), scheduleFormat: 1 },
    { name: 'postedDaySevenId', id: listPostedSchedules.postedDaySevenId, startDate: moment().set('year', thisYear).add(6, 'day').format('L'), scheduleFormat: 1 },
    { name: 'postedDayEightId', id: listPostedSchedules.postedDayEightId, startDate: moment().set('year', thisYear).add(7, 'day').format('L'), scheduleFormat: 1 },
    { name: 'postedDayNineId', id: listPostedSchedules.postedDayNineId, startDate: moment().set('year', thisYear).add(8, 'day').format('L'), scheduleFormat: 1 },
  ];
}

export default generateQuickScheduleView;



// WEBPACK FOOTER //
// ./src/Components/Schedule/generateQuickScheduleArray.js